import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { FlexProps } from 'UIKit/Box/types'
import { RowBetween } from 'layout/Components/Row'
import { Trans } from 'react-i18next'
import { InHouseGameNumericalInput, InhouseGameInputContainer, InHouseLabel } from 'views/InhouseGame/components/styled'

const Totalbet: React.FC<
  {
    totalBet: number
    onChangeTotalBet: (amount: number) => void
    disabled?: boolean
  } & FlexProps
> = ({ totalBet, onChangeTotalBet, height, disabled, ...props }) => {
  return (
    <Flex flexDirection="column" {...props}>
      <RowBetween>
        <InHouseLabel>
          <Trans>Number of Bets</Trans>
        </InHouseLabel>
      </RowBetween>
      <InhouseGameInputContainer width="100%" height={height}>
        <InHouseGameNumericalInput
          disabled={disabled}
          placeholder="0"
          px="12px"
          autoFocus={false}
          tabIndex={1}
          value={totalBet}
          onValueChanged={(e) => {
            onChangeTotalBet(e.split('.')?.[0] ? e : e)
          }}
          validateOnchange
          style={{
            textAlign: 'left',
          }}
        />
        <Box p="12px">{(!totalBet || totalBet == 0) && '♾️'}</Box>
      </InhouseGameInputContainer>
    </Flex>
  )
}

export default Totalbet
